module.exports = __webpack_public_path__ + "static/media/actions.c0c60990.svg";